module.exports = __webpack_public_path__ + "media/site_templates/www.hirecleaners.com.au/images/about_us-32ab9b47ccaf2b16307865629ae9e5d8.jpg";